import { getSettings, getProduct, getProductPaths } from 'lib/sanity.client'
import { gqlProductQuery } from 'lib/sanity.queries'
import { shopClient } from 'lib/shopify.client'
import { request } from 'graphql-request'
import { parseGid } from 'lib/helpers'

import { ProductPage } from 'components/Product/ProductPage'

export default function Product({ product, shopifyProduct }) {
  return <ProductPage product={product} shopifyProduct={shopifyProduct} />
}

// export async function getStaticPaths() {
//   const paths = await getProductPaths()

//   return {
//     paths,
//     fallback: false,
//   }
// }

export async function getServerSideProps({ params }) {
  const shopifyData: any = await request({
    url: shopClient.getStorefrontApiUrl(),
    document: gqlProductQuery,
    variables: {
      slug: params.slug,
    },
    requestHeaders: shopClient.getPublicTokenHeaders(),
  })

  const key = process.env.NEXT_PUBLIC_JUNIP_STORE_KEY
  const id = parseGid(shopifyData?.product?.id)
  const reviewData: any = await fetch(
    `https://api.juniphq.com/v1/products?filter[remote_ids]=${id}`,
    {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Junip-Store-Key': key,
      } as any,
    }
  ).then((res) => res.json())

  const [settings, product] = await Promise.all([
    getSettings(),
    getProduct(params.slug),
  ])

  if (!product) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      settings,
      product: {
        reviews: {
          id: reviewData?.products[0]?.id ?? null,
          count:
            reviewData?.products?.length >= 1
              ? reviewData?.products[0]?.rating_count
              : null,
          average: reviewData?.products?.length
            ? reviewData?.products[0]?.rating_average
            : null,
        },
        ...product,
      },
      shopifyProduct: shopifyData.product,
    },
  }
}
